import { FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { StreakCalendarBookCover } from './StreakCalendarBookCover'
import { StreakStat } from 'app/webview/pages/stats_profile/lib/types'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { useStatsPermission } from 'app/webview/pages/stats_profile/lib/hooks'

interface Props {
  streak: StreakStat
}

export const StreakCalendarBooks = ({ streak }: Props) => {
  const { colors } = useTheme()
  const stats = useStats((s) => s.stats)
  const { isStatsOwner } = useStatsPermission()
  const hide = !isStatsOwner && stats?.is_finished_list_private

  if (!streak.covers.length || hide) return null

  const maxBooks = 5
  const uniqueCovers = streak.covers.filter(
    (cover, i) => streak.covers.indexOf(cover) === i
  )
  const covers = uniqueCovers.slice(0, maxBooks)
  const remaining =
    uniqueCovers.length > maxBooks ? uniqueCovers.length - maxBooks : 0

  return (
    <>
      {remaining > 0 ? (
        <FlexBox
          className={css`
            padding: 0 2px;
            min-width: 18px;
            max-width: 24px;
            height: 16px;
            position: absolute;
            top: 2px;
            right: 2px;
            border-radius: 10px;
            background-color: ${colors.uiWhite};
            overflow: hidden;
          `}
          centerAll
        >
          <Text
            type="label"
            sizing="S"
            weight="500"
            align="center"
            color={colors.uiGreenUltraDark}
          >
            +{remaining}
          </Text>
        </FlexBox>
      ) : null}
      <div
        className={cx(
          'anim__streak-calendar-books',
          css`
            width: 100%;
            height: 100%;
            position: absolute;
            bottom: -2px;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            opacity: 0;
            transform: translateY(20px);
            will-change: transform, opacity;
          `
        )}
      >
        {covers.map((cover, i) => (
          <StreakCalendarBookCover
            key={i}
            className={css`
              position: absolute;
              left: calc(30% + ${i * 6}px);
              bottom: 0;
            `}
            cover={cover}
          />
        ))}
      </div>
    </>
  )
}
